import { POST } from './apiHelper'

const prefix = ''

export function getUnitParams({ periods }) {
  return POST(`${prefix}/unit`, { periods })
}
